// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"3e0ca634","488":"87ff362d","600":"c6050ec4","691":"50ee8d51","722":"4761edb7"}[chunkId] + ".chunk.js";
};